import type { ReactNode } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { Styles, css } from '@flipster/styled-system/css';

export const SparkRewardRules = ({
  css: cssProp,
  TermsAndConditionsCta = 'span',
}: {
  css?: Styles;
  TermsAndConditionsCta?:
    | string
    | ((props: { className?: string; children?: ReactNode; onClick?: () => unknown }) => ReactNode);
}) => {
  return (
    <div
      className={css(
        {
          gridColumn: 'full',
          display: 'grid',
          gridTemplateColumns: 'inherit',
          pt: 20,
          pb: 56,
          bg: 'background.default.level-0',
        },
        cssProp,
      )}
    >
      <div className={css({ gridColumn: 'content' })}>
        <h3 className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5', mb: 12 })}>
          <FormattedMessage id='Autogen_common.r251126.s_Rules' />
        </h3>
        <ul
          className={css({
            '& > li': {
              textStyle: 'Text/M/Regular',
              position: 'relative',
              paddingLeft: 24,
              color: 'content.default.level-1',
              _before: {
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 6,
                content: "'•'",
              },
            },
          })}
        >
          <li>
            <FormattedMessage id='Autogen_common.r251126.s_Earn_Sparks_Now_Season_1_is_a_limited_time_event_You_can_earn_sparks_from_24_09_12_00_00_UTC_to_25_01_12_00_00_UTC' />
          </li>
          <li>
            <FormattedMessage id='Autogen_common.r251126.s_Sparks_are_settled_every_24_hours_at_00_00_UTC' />
          </li>
          <li>
            By participating in this event, users agree to comply with Flipster’s{' '}
            <TermsAndConditionsCta className={css({ textStyle: 'Text/M/Underline', color: 'inherit' })}>
              <FormattedMessage id='Autogen_common.r251126.s_terms_and_conditions' />
            </TermsAndConditionsCta>
          </li>
        </ul>
      </div>
    </div>
  );
};
